import { produce } from 'immer';
import { AnyAction, Reducer } from 'redux';
import { Optional } from '../../../../lib/types/Optional';
import { IPermission, IUserInfo } from '../interfaces/Authentication.types';
import { IAuthenticationTokens } from '../interfaces/IAuthenticationTokens';
import { AuthenticationActions } from './authenticationActions';

export interface IAuthenticationState {
  isCheckingAuthentication: boolean;
  isLoggedIn: boolean;
  tokens: Optional<IAuthenticationTokens>;
  permissions: IPermission[];
  userInfo: IUserInfo;
}

export const initialState: IAuthenticationState = {
  isCheckingAuthentication: true,
  isLoggedIn: false,
  tokens: null,
  permissions: [],
  userInfo: {},
};

export const authenticationReducer: Reducer<IAuthenticationState, AnyAction> = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case AuthenticationActions.CHECK_AUTHENTICATION: {
        draft.isCheckingAuthentication = true;
        break;
      }

      case AuthenticationActions.CHECK_AUTHENTICATION_AUTHENTICATED: {
        const { tokens, permissions } = action.payload;

        draft.isCheckingAuthentication = false;
        draft.isLoggedIn = true;
        draft.tokens = tokens;
        draft.permissions = permissions;
        break;
      }

      case AuthenticationActions.CHECK_AUTHENTICATION_NOT_AUTHENTICATED: {
        draft.isCheckingAuthentication = false;
        break;
      }

      case AuthenticationActions.TOKEN_REFRESHED: {
        const { tokens, permissions } = action.payload;

        draft.isLoggedIn = true;
        draft.tokens = tokens;
        draft.permissions = permissions;
        break;
      }

      case AuthenticationActions.SET_USER_INFO: {
        const { userInfo } = action.payload ?? {};

        draft.userInfo.customerId = userInfo?.['custom:customerId'];
        draft.userInfo.email = userInfo?.email;
        draft.userInfo.title = userInfo?.['custom:title'];
        draft.userInfo.displayName = userInfo?.['custom:displayName'];
        draft.userInfo.phoneNumber = userInfo?.['custom:phoneNumber'];
        draft.userInfo.preferredLanguage = userInfo?.['custom:preferredLanguage'];
        break;
      }

      default:
        break;
    }
  });
